export default __webpack_public_path__ + "static/media/checkbox-checked.04ae7039.svg";